import React from 'react';
import { styled } from 'styled-components';
import AppCSS from '../../utils/styled';
import { MessageSender, MessageWrapper } from './Message';

export function TypingIndicator() {
  return (
    <MessageWrapper $isUser={false}>
      <MessageSender $isUser={false}>Assistant</MessageSender>
      <TypingIndicatorContainer>
        <TypingDots>
          <span />
          <span />
          <span />
        </TypingDots>
      </TypingIndicatorContainer>
    </MessageWrapper>
  );
}

const TypingDots = styled.div`
  display: flex;
  gap: 4px;

  span {
    width: 6px;
    height: 6px;
    background-color: ${AppCSS.colors.greys.medium};
    border-radius: 50%;
    animation: typing 1.4s infinite ease-in-out;

    &:nth-child(1) {
      animation-delay: 0s;
    }
    &:nth-child(2) {
      animation-delay: 0.2s;
    }
    &:nth-child(3) {
      animation-delay: 0.4s;
    }
  }

  @keyframes typing {
    0%,
    60%,
    100% {
      transform: translateY(0);
      opacity: 0.4;
    }
    30% {
      transform: translateY(-10px);
      opacity: 1;
    }
  }
`;

const TypingIndicatorContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: ${AppCSS.colors.white};
  border: 1px solid ${AppCSS.colors.greys.light};
  ${AppCSS.radiuses.regular};
  border-bottom-left-radius: 4px;
  max-width: 70%;
  ${AppCSS.boxShadows.block};
`;
